function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.86 1.06a.5.5 0 010-.71l.2-.2A.49.49 0 011.42 0h7.16a.49.49 0 01.36.15l.2.2a.5.5 0 010 .71L5.35 4.85a.48.48 0 01-.7 0L.86 1.06z"
});

var SvgArrowDropdown = function SvgArrowDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgArrowDropdown;